export var BASELINE_GRID = {
    EXTRA_EXTRA_LARGE: {
        MIN: 12,
        MAX: 12,
        VIEWPORT: 12,
    },
    EXTRA_LARGE: {
        MIN: 12,
        MAX: 12,
        VIEWPORT: 12,
    },
    LARGE: {
        MIN: 10,
        MAX: 12,
        VIEWPORT: 12,
    },
    MEDIUM: {
        MIN: 7,
        MAX: 9,
        VIEWPORT: 8,
    },
    SMALL: {
        MIN: 4,
        MAX: 6,
        VIEWPORT: 4,
    },
    EXTRA_SMALL: {
        MIN: 1,
        MAX: 3,
        VIEWPORT: 4,
    },
};
//# sourceMappingURL=baseline-grid.js.map